import LogisticsCompany from "@/enum/LogisticsCompany";
import httpClient from "../http/mainServerClient";

const redirectUrl = import.meta.env.VITE_IS_QN ? undefined : "/setting/ewaybillAccount";

interface AuthUrlResult {
    url: string;
}

// 构建获取京东无界电子面单账号授权 URL
export function buildJDUrl(): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/jdwj/url", { redirectUrl });
}

// 构建获取京东物流云电子面单账号授权 URL
export function buildJDLUrl(username: string): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/jdl/url", { username, redirectUrl });
}

// 构建获取京东官方快递电子面单授权 URL
export function buildJDOfficialUrl(logisticsCompany: LogisticsCompany, username: string): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/jdwl/url", {
        logisticsCompany,
        username,
        redirectUrl,
    });
}

export function buildJinRiTeMaiUrl(isJinritemaiAuth?: boolean): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/jinritemai/url", { redirectUrl, isJinritemaiAuth });
}

export function buildKWaiEwaybillUrl(): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/kwaishop/url", { redirectUrl });
}

export function buildTaoBaoEwaybillAuthUrl(): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/taobao/url", { redirectUrl });
}

export function buildPddEwaybillAuthUrl(isShop: boolean): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/pdd/url", { redirectUrl, isShop });
}

export function buildXiaoHongShuEwaybillAuthUrl(isShop: boolean): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/xiaohongshu/url", { redirectUrl, isShop });
}

export function buildReAuthUrl(ewaybillAccountId: number): Promise<AuthUrlResult> {
    return httpClient.get("/ewaybill/auth/reauth/url", { ewaybillAccountId, redirectUrl });
}
